import { memo, useMemo } from "react";
import { MarkdownBlock } from "./markdown-block";

export const EnrichedBlock = memo(({ text }: { text: string }) => {
  // Memoize the text replacement to prevent unnecessary re-renders
  const replacedText = useMemo(() => escapeLaTeX(text), [text]);
  return <MarkdownBlock text={replacedText} />;
});

// Replace inline LaTeX syntax \(...\) with backticks
const INLINE_LATEX_PATTERN = /\\\((.*?)\\\)/g;
const INLINE_LATEX_REPLACEMENT = "`latex:\\($1\\)`";

// Replace block LaTeX syntax \[...\], preserving any indentation
//
// Explanation of the regex:
//   ^(\s*)        - Capture any leading indentation at the start of the line in group 1
//   \\\[          - Match literal "\[" (backslash-escaped in a JS string)
//   ([\s\S]*?)    - Capture everything inside the block (including newlines) non-greedily in group 2
//   \\\]          - Match literal "\]"
//
// The 'm' (multiline) flag lets ^ and $ work line-by-line.
// [\s\S] is a common trick to match absolutely everything (newlines included).
//
const BLOCK_LATEX_PATTERN = /^(\s*)\\\[([\s\S]*?)\\\]/gm;
const BLOCK_LATEX_REPLACEMENT = "$1```latex\n$1\\[$2\\]\n$1```";

const BOXED_LATEX_PATTERN = /^(\s*)\\boxed\{([\s\S]*?)\}/gm;
const BOXED_LATEX_REPLACEMENT = "$1```\n$2\n$1```";

const BOXED_BLOCK_LATEX_PATTERN = /^(\s*)\\\[\s*\\boxed\{([\s\S]*?)\}\s*\\]/gm;
const BOXED_BLOCL_LATEX_REPLACEMENT = "$1```\n$2\n$1```";

function escapeLaTeX(input: string): string {
  // Replace inline LaTeX first
  let output = input.replace(INLINE_LATEX_PATTERN, INLINE_LATEX_REPLACEMENT);

  // Replace boxed block LaTeX
  output = output.replace(
    BOXED_BLOCK_LATEX_PATTERN,
    BOXED_BLOCL_LATEX_REPLACEMENT,
  );

  // Then perform the block replacements
  output = output.replace(BLOCK_LATEX_PATTERN, BLOCK_LATEX_REPLACEMENT);

  // Then perform the boxed replacements
  output = output.replace(BOXED_LATEX_PATTERN, BOXED_LATEX_REPLACEMENT);

  return output;
}
